export enum LearningMenuType {
    None = "None",
    CourseMenu = "CourseMenu",
    Description = "Description",
    CodeOutPut = "CodeOutPut",
    AnswerCode = "AnswerCode",
    AssessmentSetMenu = "AssessmentSetMenu",
    Preview = "Preview",
    GuideLines = "GuideLines"
}

export default LearningMenuType;
